import { jsx as t } from "react/jsx-runtime";
import { GlobalNavv2Category as i } from "./GlobalNavv2Category.mjs";
import { ArrowRightFromBracketIcon as a } from "../icons/componentIcons.mjs";
import { useGlobalHeaderv2PrivateContext as n } from "../navigation/GlobalHeader/useGlobalHeaderv2Context.mjs";
const g = ({
  ...e
}) => {
  const { onSignOutClick: o } = n();
  return /* @__PURE__ */ t(
    i,
    {
      label: "Sign Out",
      icon: /* @__PURE__ */ t(a, { variant: "light" }),
      onClick: o,
      onKeyDown: (r) => {
        r.key === "Enter" && (o == null || o(r));
      },
      ...e
    }
  );
};
export {
  g as MobileSignOutCategory
};
